const getOr = require('lodash/fp/getOr');
const find = require('lodash/fp/find');

class SelectPaymentController {
  static get $inject() {
    return [
      '$stateParams',
      'payments',
      'editPaymentModal',
      '$scope',
      '$q',
      'toastService',
      '$translate'
    ];
  }

  constructor($stateParams, payments, editPaymentModal, $scope, $q, toastService, $translate) {
    this.editPaymentModal = editPaymentModal;
    this.$close = $scope.$close.bind($scope);
    this.$q = $q;
    this.toastService = toastService;
    this.$translate = $translate;
    this.shipment = $stateParams.shipment;

    const selectedId = this.shipment.paymentId;
    this.payments = payments.filter(it => (it.publicId === selectedId || !it.ccExpDate.isExpired));

    this.useForAll = true;
    this.selectedPayment = find({ publicId: selectedId }, payments);

    this._displayError = this._displayError.bind(this);
  }

  _displayError(err) {
    this.error = getOr(this.$translate.instant('TOAST_CHANGE_BILLING_DANGER'), 'error_message', err);
    return this.$q.reject(err);
  }

  submit(selectedId, useForAll) {
    delete this.error;

    this.submitting = this.editPaymentModal.submit(selectedId, useForAll)
      .then(() => this.toastService.translate.success('TOAST_CHANGE_BILLING_SUCCESS'))
      .then(this.$close, this._displayError)
      .catch(() => this.toastService.translate.danger('TOAST_CHANGE_BILLING_DANGER'));

    return this.submitting;
  }
}

angular.module('msi.payments.select')
  .controller('SelectPaymentController', SelectPaymentController);

module.exports = SelectPaymentController;
